<template>
    <div>
        <div class="notice">
            {{ $t('gamesUnavailableError') }}.
        </div>
        <Illustration xl image="/static/img/illustrations/casino__maintenance.svg"/>
    </div>
</template>

<script>

    export default {
        name: 'GameUnavailableModal',
    };
</script>



// WEBPACK FOOTER //
// src/app/modals/modals/games/GameUnavailableModal.vue